import { loginModel } from '../../constants/models';

const { ACCESS_TOKEN, REFRESH_TOKEN, USERNAME, FULL_NAME, PORTAL, USER_STATUS, STAKEHOLDER_TYPE } = loginModel;

export const setAccessToken = token => localStorage.setItem(ACCESS_TOKEN, token);
export const getAccessToken = () => localStorage.getItem(ACCESS_TOKEN);
export const removeAccessToken = () => localStorage.removeItem(ACCESS_TOKEN);

export const setRefreshToken = token => localStorage.setItem(REFRESH_TOKEN, token);
export const getRefreshToken = () => localStorage.getItem(REFRESH_TOKEN);
export const removeRefreshToken = () => localStorage.removeItem(REFRESH_TOKEN);

export const setUsername = username => localStorage.setItem(USERNAME, username);
export const getUsername = () => localStorage.getItem(USERNAME);
export const removeUsername = () => localStorage.removeItem(USERNAME);

export const setFullname = username => localStorage.setItem(FULL_NAME, username);
export const getFullname = () => localStorage.getItem(FULL_NAME);
export const removeFullname = () => localStorage.removeItem(FULL_NAME);

export const setUserStatus = status => localStorage.setItem(USER_STATUS, status);
export const getUserStatus = () => localStorage.getItem(USER_STATUS);
export const removeUserStatus = () => localStorage.removeItem(USER_STATUS);


export const setPortal = portal => localStorage.setItem(PORTAL, portal);
export const getPortal = () => localStorage.getItem(PORTAL);
export const removePortal = () => localStorage.removeItem(PORTAL);

export const setStakeholderType = stakeholderType => localStorage.setItem(STAKEHOLDER_TYPE, stakeholderType);
export const getStakeholderType = () => localStorage.getItem(STAKEHOLDER_TYPE);
export const removeStakeholderType = () => localStorage.removeItem(STAKEHOLDER_TYPE);

const STOCK_MATCH_ANNOUNCEMENT_FLAG = 'isStockMatchAnnouncementEnabled';

export const setStockMatchAnnouncementFlag = flag => {
  if (flag !== null && flag !== undefined) {
    sessionStorage.setItem(STOCK_MATCH_ANNOUNCEMENT_FLAG, JSON.stringify(!!flag));
  }
};

export const getStockMatchAnnouncementFlag = () => {
  const flag = sessionStorage.getItem(STOCK_MATCH_ANNOUNCEMENT_FLAG);
  if (flag === null || flag === undefined) {
    return false;
  }
  try {
    return JSON.parse(flag) === true;
  } catch {
    return false;
  }
};

export const removeStockMatchAnnouncementFlag = () => {
  sessionStorage.removeItem(STOCK_MATCH_ANNOUNCEMENT_FLAG);
};

export const getAllAuthRequestFields = () => ({
  Authorization: `Bearer ${getAccessToken()}`
});

